import { useMutation } from "@tanstack/react-query";
import { updateLeatVisitsSettings } from "../../api/bLeatApi";

export const useUpdateLeatVisitsSettings = () => {
  return useMutation({
    mutationKey: ["update-leat-visits-settings"],
    mutationFn: (data) => updateLeatVisitsSettings(data),
    onError: (error) => {
      console.error("Leat visits settings error:", error.response || error);
    },
  });
};
